import { IMAGE_TYPE } from "@/app/enums/ui";

const imgUrl = process.env.ICM_IMAGES_URL + IMAGE_TYPE.PNG;

export const HOW_TO_FD_STEPS = [
    {
        img: `${imgUrl}/how-to-fd-1.png`,
        title: "Select an FD",
        subTitle: "Choose an FD you’d like to book from our list",
        arrow: `${imgUrl}/how-to-arrow-1.png`,
    },
    {
        img: `${imgUrl}/how-to-fd-2.png`,
        title: "Pay to book the FD",
        subTitle: "Make a payment from your bank account",
        arrow: `${imgUrl}/how-to-arrow-2.png`,
    },
    {
        img: `${imgUrl}/how-to-fd-3.png`,
        title: "Check your InCred Money portfolio",
        subTitle: "Your newly booked FD should now be added",
    },
];

export const WHY_ICM_FD = [
    {
        id: 1,
        title: "Earn ₹250 on first bank FD",
        img: `${imgUrl}/why-fd-1.png`,
        content:
            "Book Fixed Deposits (FDs) with any of our partners through our app and get a ₹250 voucher on your first FD booking!",
    },
    {
        id: 2,
        title: "Wide Range of Banks to choose from",
        img: `${imgUrl}/why-fd-2.png`,
        content:
            "Invest with confidence! Your savings are secure with our partners, ensuring peace of mind every step of the way",
    },
    {
        id: 3,
        title: "No bank account opening required",
        img: `${imgUrl}/why-fd-3.png`,
        content:
            "No need to open a new bank account! Simply use your existing account to book an FD with ease.",
    },
];

export enum CompoundingFrequency {
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    SemiAnnually = "Semi-annually",
    Yearly = "Yearly",
}